// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/pool.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message mlmbox.types.Pool
 */
export interface Pool {
}
/**
 * @generated from protobuf message mlmbox.types.Pool.Hunter
 */
export interface Pool_Hunter {
    /**
     * @generated from protobuf field: mlmbox.types.Pool.Hunter.Info info = 1;
     */
    info?: Pool_Hunter_Info;
    /**
     * @generated from protobuf field: repeated mlmbox.types.Pool.Hunter.Card.Info cards = 2;
     */
    cards: Pool_Hunter_Card_Info[];
}
/**
 * @generated from protobuf message mlmbox.types.Pool.Hunter.Info
 */
export interface Pool_Hunter_Info {
    /**
     * @generated from protobuf field: uint32 asset_id = 1;
     */
    assetId: number; // идентификатор валюты
    /**
     * @generated from protobuf field: string accumulated_value = 2;
     */
    accumulatedValue: string; // накопленное значение суммы пула
    /**
     * @generated from protobuf field: uint32 next_distribution_at = 3;
     */
    nextDistributionAt: number; // дата и время следующего распределения пула
}
/**
 * @generated from protobuf message mlmbox.types.Pool.Hunter.History
 */
export interface Pool_Hunter_History {
    /**
     * @generated from protobuf field: uint32 distribution_id = 1;
     */
    distributionId: number; // уникальный идентификатор распределения пула
    /**
     * @generated from protobuf field: string distribution_value = 2;
     */
    distributionValue: string; // сумма распределения пула
    /**
     * @generated from protobuf field: uint32 quantity_cards = 3;
     */
    quantityCards: number; // количество карт участвовавшие в распределении
    /**
     * @generated from protobuf field: uint32 quantity_accounts = 4;
     */
    quantityAccounts: number; // количество аккаунтов участвовавшие в распределении
    /**
     * @generated from protobuf field: uint32 created_at = 5;
     */
    createdAt: number; // дата и время создания распределения
}
/**
 * @generated from protobuf message mlmbox.types.Pool.Hunter.History.List
 */
export interface Pool_Hunter_History_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Pool.Hunter.History items = 1;
     */
    items: Pool_Hunter_History[];
}
/**
 * @generated from protobuf message mlmbox.types.Pool.Hunter.Card
 */
export interface Pool_Hunter_Card {
    /**
     * @generated from protobuf field: mlmbox.types.Pool.Hunter.Card.Info info = 1;
     */
    info?: Pool_Hunter_Card_Info;
    /**
     * @generated from protobuf field: repeated mlmbox.types.Pool.Hunter.Card.Transaction transactions = 2;
     */
    transactions: Pool_Hunter_Card_Transaction[];
}
/**
 * @generated from protobuf message mlmbox.types.Pool.Hunter.Card.Id
 */
export interface Pool_Hunter_Card_Id {
    /**
     * @generated from protobuf field: uint32 card_id = 1;
     */
    cardId: number;
}
/**
 * @generated from protobuf message mlmbox.types.Pool.Hunter.Card.Info
 */
export interface Pool_Hunter_Card_Info {
    /**
     * @generated from protobuf field: uint32 card_id = 1;
     */
    cardId: number; // идентификатор карты пула пользователя
    /**
     * @generated from protobuf field: uint32 created_at = 2;
     */
    createdAt: number; // дата и время создания карты
    /**
     * @generated from protobuf field: uint32 energy_init = 3;
     */
    energyInit: number; // начальное значение энергии карты
    /**
     * @generated from protobuf field: uint32 energy_total = 4;
     */
    energyTotal: number; // общее значение энергии карты
    /**
     * @generated from protobuf field: uint32 energy_value = 5;
     */
    energyValue: number; // текущее значение энергии карты
    /**
     * @generated from protobuf field: string earned_total_value = 6;
     */
    earnedTotalValue: string; // общее значение заработанной суммы карты
}
/**
 * @generated from protobuf message mlmbox.types.Pool.Hunter.Card.Info.List
 */
export interface Pool_Hunter_Card_Info_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Pool.Hunter.Card.Info items = 1;
     */
    items: Pool_Hunter_Card_Info[];
}
/**
 * @generated from protobuf message mlmbox.types.Pool.Hunter.Card.Transaction
 */
export interface Pool_Hunter_Card_Transaction {
    /**
     * @generated from protobuf field: uint32 distribution_id = 1;
     */
    distributionId: number; // уникальный идентификатор распределения пула
    /**
     * @generated from protobuf field: string distribution_value = 2;
     */
    distributionValue: string; // сумма распределения пула
    /**
     * @generated from protobuf field: string earned_value = 3;
     */
    earnedValue: string; // заработанная сумма пользователем
    /**
     * @generated from protobuf field: uint32 created_at = 4;
     */
    createdAt: number; // дата и время создания транзакции
}
/**
 * @generated from protobuf message mlmbox.types.Pool.Hunter.Card.Transaction.List
 */
export interface Pool_Hunter_Card_Transaction_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Pool.Hunter.Card.Transaction transactions = 1;
     */
    transactions: Pool_Hunter_Card_Transaction[];
}
// @generated message type with reflection information, may provide speed optimized methods
class Pool$Type extends MessageType<Pool> {
    constructor() {
        super("mlmbox.types.Pool", []);
    }
    create(value?: PartialMessage<Pool>): Pool {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Pool>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Pool): Pool {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Pool, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Pool
 */
export const Pool = new Pool$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pool_Hunter$Type extends MessageType<Pool_Hunter> {
    constructor() {
        super("mlmbox.types.Pool.Hunter", [
            { no: 1, name: "info", kind: "message", T: () => Pool_Hunter_Info },
            { no: 2, name: "cards", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Pool_Hunter_Card_Info }
        ]);
    }
    create(value?: PartialMessage<Pool_Hunter>): Pool_Hunter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cards = [];
        if (value !== undefined)
            reflectionMergePartial<Pool_Hunter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Pool_Hunter): Pool_Hunter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Pool.Hunter.Info info */ 1:
                    message.info = Pool_Hunter_Info.internalBinaryRead(reader, reader.uint32(), options, message.info);
                    break;
                case /* repeated mlmbox.types.Pool.Hunter.Card.Info cards */ 2:
                    message.cards.push(Pool_Hunter_Card_Info.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Pool_Hunter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Pool.Hunter.Info info = 1; */
        if (message.info)
            Pool_Hunter_Info.internalBinaryWrite(message.info, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Pool.Hunter.Card.Info cards = 2; */
        for (let i = 0; i < message.cards.length; i++)
            Pool_Hunter_Card_Info.internalBinaryWrite(message.cards[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Pool.Hunter
 */
export const Pool_Hunter = new Pool_Hunter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pool_Hunter_Info$Type extends MessageType<Pool_Hunter_Info> {
    constructor() {
        super("mlmbox.types.Pool.Hunter.Info", [
            { no: 1, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "accumulated_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "next_distribution_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Pool_Hunter_Info>): Pool_Hunter_Info {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetId = 0;
        message.accumulatedValue = "";
        message.nextDistributionAt = 0;
        if (value !== undefined)
            reflectionMergePartial<Pool_Hunter_Info>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Pool_Hunter_Info): Pool_Hunter_Info {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_id */ 1:
                    message.assetId = reader.uint32();
                    break;
                case /* string accumulated_value */ 2:
                    message.accumulatedValue = reader.string();
                    break;
                case /* uint32 next_distribution_at */ 3:
                    message.nextDistributionAt = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Pool_Hunter_Info, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_id = 1; */
        if (message.assetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.assetId);
        /* string accumulated_value = 2; */
        if (message.accumulatedValue !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accumulatedValue);
        /* uint32 next_distribution_at = 3; */
        if (message.nextDistributionAt !== 0)
            writer.tag(3, WireType.Varint).uint32(message.nextDistributionAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Pool.Hunter.Info
 */
export const Pool_Hunter_Info = new Pool_Hunter_Info$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pool_Hunter_History$Type extends MessageType<Pool_Hunter_History> {
    constructor() {
        super("mlmbox.types.Pool.Hunter.History", [
            { no: 1, name: "distribution_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "distribution_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "quantity_cards", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "quantity_accounts", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "created_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Pool_Hunter_History>): Pool_Hunter_History {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.distributionId = 0;
        message.distributionValue = "";
        message.quantityCards = 0;
        message.quantityAccounts = 0;
        message.createdAt = 0;
        if (value !== undefined)
            reflectionMergePartial<Pool_Hunter_History>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Pool_Hunter_History): Pool_Hunter_History {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 distribution_id */ 1:
                    message.distributionId = reader.uint32();
                    break;
                case /* string distribution_value */ 2:
                    message.distributionValue = reader.string();
                    break;
                case /* uint32 quantity_cards */ 3:
                    message.quantityCards = reader.uint32();
                    break;
                case /* uint32 quantity_accounts */ 4:
                    message.quantityAccounts = reader.uint32();
                    break;
                case /* uint32 created_at */ 5:
                    message.createdAt = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Pool_Hunter_History, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 distribution_id = 1; */
        if (message.distributionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.distributionId);
        /* string distribution_value = 2; */
        if (message.distributionValue !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.distributionValue);
        /* uint32 quantity_cards = 3; */
        if (message.quantityCards !== 0)
            writer.tag(3, WireType.Varint).uint32(message.quantityCards);
        /* uint32 quantity_accounts = 4; */
        if (message.quantityAccounts !== 0)
            writer.tag(4, WireType.Varint).uint32(message.quantityAccounts);
        /* uint32 created_at = 5; */
        if (message.createdAt !== 0)
            writer.tag(5, WireType.Varint).uint32(message.createdAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Pool.Hunter.History
 */
export const Pool_Hunter_History = new Pool_Hunter_History$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pool_Hunter_History_List$Type extends MessageType<Pool_Hunter_History_List> {
    constructor() {
        super("mlmbox.types.Pool.Hunter.History.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Pool_Hunter_History }
        ]);
    }
    create(value?: PartialMessage<Pool_Hunter_History_List>): Pool_Hunter_History_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Pool_Hunter_History_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Pool_Hunter_History_List): Pool_Hunter_History_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Pool.Hunter.History items */ 1:
                    message.items.push(Pool_Hunter_History.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Pool_Hunter_History_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Pool.Hunter.History items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Pool_Hunter_History.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Pool.Hunter.History.List
 */
export const Pool_Hunter_History_List = new Pool_Hunter_History_List$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pool_Hunter_Card$Type extends MessageType<Pool_Hunter_Card> {
    constructor() {
        super("mlmbox.types.Pool.Hunter.Card", [
            { no: 1, name: "info", kind: "message", T: () => Pool_Hunter_Card_Info },
            { no: 2, name: "transactions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Pool_Hunter_Card_Transaction }
        ]);
    }
    create(value?: PartialMessage<Pool_Hunter_Card>): Pool_Hunter_Card {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactions = [];
        if (value !== undefined)
            reflectionMergePartial<Pool_Hunter_Card>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Pool_Hunter_Card): Pool_Hunter_Card {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Pool.Hunter.Card.Info info */ 1:
                    message.info = Pool_Hunter_Card_Info.internalBinaryRead(reader, reader.uint32(), options, message.info);
                    break;
                case /* repeated mlmbox.types.Pool.Hunter.Card.Transaction transactions */ 2:
                    message.transactions.push(Pool_Hunter_Card_Transaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Pool_Hunter_Card, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Pool.Hunter.Card.Info info = 1; */
        if (message.info)
            Pool_Hunter_Card_Info.internalBinaryWrite(message.info, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Pool.Hunter.Card.Transaction transactions = 2; */
        for (let i = 0; i < message.transactions.length; i++)
            Pool_Hunter_Card_Transaction.internalBinaryWrite(message.transactions[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Pool.Hunter.Card
 */
export const Pool_Hunter_Card = new Pool_Hunter_Card$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pool_Hunter_Card_Id$Type extends MessageType<Pool_Hunter_Card_Id> {
    constructor() {
        super("mlmbox.types.Pool.Hunter.Card.Id", [
            { no: 1, name: "card_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Pool_Hunter_Card_Id>): Pool_Hunter_Card_Id {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cardId = 0;
        if (value !== undefined)
            reflectionMergePartial<Pool_Hunter_Card_Id>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Pool_Hunter_Card_Id): Pool_Hunter_Card_Id {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 card_id */ 1:
                    message.cardId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Pool_Hunter_Card_Id, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 card_id = 1; */
        if (message.cardId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.cardId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Pool.Hunter.Card.Id
 */
export const Pool_Hunter_Card_Id = new Pool_Hunter_Card_Id$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pool_Hunter_Card_Info$Type extends MessageType<Pool_Hunter_Card_Info> {
    constructor() {
        super("mlmbox.types.Pool.Hunter.Card.Info", [
            { no: 1, name: "card_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "created_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "energy_init", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "energy_total", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "energy_value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "earned_total_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Pool_Hunter_Card_Info>): Pool_Hunter_Card_Info {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cardId = 0;
        message.createdAt = 0;
        message.energyInit = 0;
        message.energyTotal = 0;
        message.energyValue = 0;
        message.earnedTotalValue = "";
        if (value !== undefined)
            reflectionMergePartial<Pool_Hunter_Card_Info>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Pool_Hunter_Card_Info): Pool_Hunter_Card_Info {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 card_id */ 1:
                    message.cardId = reader.uint32();
                    break;
                case /* uint32 created_at */ 2:
                    message.createdAt = reader.uint32();
                    break;
                case /* uint32 energy_init */ 3:
                    message.energyInit = reader.uint32();
                    break;
                case /* uint32 energy_total */ 4:
                    message.energyTotal = reader.uint32();
                    break;
                case /* uint32 energy_value */ 5:
                    message.energyValue = reader.uint32();
                    break;
                case /* string earned_total_value */ 6:
                    message.earnedTotalValue = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Pool_Hunter_Card_Info, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 card_id = 1; */
        if (message.cardId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.cardId);
        /* uint32 created_at = 2; */
        if (message.createdAt !== 0)
            writer.tag(2, WireType.Varint).uint32(message.createdAt);
        /* uint32 energy_init = 3; */
        if (message.energyInit !== 0)
            writer.tag(3, WireType.Varint).uint32(message.energyInit);
        /* uint32 energy_total = 4; */
        if (message.energyTotal !== 0)
            writer.tag(4, WireType.Varint).uint32(message.energyTotal);
        /* uint32 energy_value = 5; */
        if (message.energyValue !== 0)
            writer.tag(5, WireType.Varint).uint32(message.energyValue);
        /* string earned_total_value = 6; */
        if (message.earnedTotalValue !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.earnedTotalValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Pool.Hunter.Card.Info
 */
export const Pool_Hunter_Card_Info = new Pool_Hunter_Card_Info$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pool_Hunter_Card_Info_List$Type extends MessageType<Pool_Hunter_Card_Info_List> {
    constructor() {
        super("mlmbox.types.Pool.Hunter.Card.Info.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Pool_Hunter_Card_Info }
        ]);
    }
    create(value?: PartialMessage<Pool_Hunter_Card_Info_List>): Pool_Hunter_Card_Info_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Pool_Hunter_Card_Info_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Pool_Hunter_Card_Info_List): Pool_Hunter_Card_Info_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Pool.Hunter.Card.Info items */ 1:
                    message.items.push(Pool_Hunter_Card_Info.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Pool_Hunter_Card_Info_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Pool.Hunter.Card.Info items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Pool_Hunter_Card_Info.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Pool.Hunter.Card.Info.List
 */
export const Pool_Hunter_Card_Info_List = new Pool_Hunter_Card_Info_List$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pool_Hunter_Card_Transaction$Type extends MessageType<Pool_Hunter_Card_Transaction> {
    constructor() {
        super("mlmbox.types.Pool.Hunter.Card.Transaction", [
            { no: 1, name: "distribution_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "distribution_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "earned_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Pool_Hunter_Card_Transaction>): Pool_Hunter_Card_Transaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.distributionId = 0;
        message.distributionValue = "";
        message.earnedValue = "";
        message.createdAt = 0;
        if (value !== undefined)
            reflectionMergePartial<Pool_Hunter_Card_Transaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Pool_Hunter_Card_Transaction): Pool_Hunter_Card_Transaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 distribution_id */ 1:
                    message.distributionId = reader.uint32();
                    break;
                case /* string distribution_value */ 2:
                    message.distributionValue = reader.string();
                    break;
                case /* string earned_value */ 3:
                    message.earnedValue = reader.string();
                    break;
                case /* uint32 created_at */ 4:
                    message.createdAt = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Pool_Hunter_Card_Transaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 distribution_id = 1; */
        if (message.distributionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.distributionId);
        /* string distribution_value = 2; */
        if (message.distributionValue !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.distributionValue);
        /* string earned_value = 3; */
        if (message.earnedValue !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.earnedValue);
        /* uint32 created_at = 4; */
        if (message.createdAt !== 0)
            writer.tag(4, WireType.Varint).uint32(message.createdAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Pool.Hunter.Card.Transaction
 */
export const Pool_Hunter_Card_Transaction = new Pool_Hunter_Card_Transaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pool_Hunter_Card_Transaction_List$Type extends MessageType<Pool_Hunter_Card_Transaction_List> {
    constructor() {
        super("mlmbox.types.Pool.Hunter.Card.Transaction.List", [
            { no: 1, name: "transactions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Pool_Hunter_Card_Transaction }
        ]);
    }
    create(value?: PartialMessage<Pool_Hunter_Card_Transaction_List>): Pool_Hunter_Card_Transaction_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactions = [];
        if (value !== undefined)
            reflectionMergePartial<Pool_Hunter_Card_Transaction_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Pool_Hunter_Card_Transaction_List): Pool_Hunter_Card_Transaction_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Pool.Hunter.Card.Transaction transactions */ 1:
                    message.transactions.push(Pool_Hunter_Card_Transaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Pool_Hunter_Card_Transaction_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Pool.Hunter.Card.Transaction transactions = 1; */
        for (let i = 0; i < message.transactions.length; i++)
            Pool_Hunter_Card_Transaction.internalBinaryWrite(message.transactions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Pool.Hunter.Card.Transaction.List
 */
export const Pool_Hunter_Card_Transaction_List = new Pool_Hunter_Card_Transaction_List$Type();
